import { render, staticRenderFns } from "./copper_structure.vue?vue&type=template&id=82f28ea8&scoped=true"
import script from "./copper_structure.vue?vue&type=script&lang=js"
export * from "./copper_structure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f28ea8",
  null
  
)

export default component.exports